import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
//anime
import Lottie from "lottie-react";
import loadingAD from "../../assets/json/load-fragmented-square.json";
const useStyles = makeStyles(() => ({
  LinearIndeterminate: {
    width: '10%'
  }
}));
const LoadingTableData = () => {
const classes = useStyles();
  return (
    <div className={classes.LinearIndeterminate}>
      <Lottie animationData={loadingAD} />
    </div>
  );
};
export default LoadingTableData;
